import { render, staticRenderFns } from "./TalentMatricesComponent.vue?vue&type=template&id=e43465d8&scoped=true"
import script from "./TalentMatricesComponent.vue?vue&type=script&lang=js"
export * from "./TalentMatricesComponent.vue?vue&type=script&lang=js"
import style0 from "./TalentMatricesComponent.vue?vue&type=style&index=0&id=e43465d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43465d8",
  null
  
)

export default component.exports